// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2vNG3","alertIcon":"ConfirmModal_alertIcon__EAfvA"};